<template>
    <div class="modal fade" ref="root" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content mb:66!@<sm">
                <div class="modal-header">
                    <h3 class="modal-title f:20! color:#333!">驗證學校信箱</h3>
                    <button class="btn-close" data-bs-dismiss="modal" type="button"></button>
                </div>
                <div class="modal-body p-0">
                    <div class="p:10|60|60">
                        <div class="f:16 color:#5E6472 mb:32">驗證後，就可以在校園趴特新增話題或與其他同學互動唷！</div>
                        <div class="f:14 f:bold color:#333333 mb:8">學校信箱</div>
                        <college-mail :closeable="false" @error="(msg) => global.error(msg)" :index="1" placeholder="例：abc123@ntu.edu.tw" @send="sendCode" @update="collegeChanged"></college-mail>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    const global = useGlobal();

    const root = ref();

    let modal;

    const collegeChanged = () => {
        modal.hide();

        useUserInfo().reload();

        global.success("大學信箱驗證成功");
    };

    const countdown = (obj) => {
        obj.countdown -= 1;

        if (obj.countdown) {
            setTimeout(() => countdown(obj), 1000);
        }
    };

    const sendCode = (obj) => {
        obj.error = false;

        api(obj.url, { target: obj.target }, { prevent: true }).done((res) => {
            if (res.success) {
                obj.countdown = 180;
                obj.pending = true;
                obj.code = "";
                setTimeout(() => countdown(obj), 1000);
                setTimeout(() => $(obj.input).focus());
            } else {
                obj.error = true;
                global.error(res.message);
            }
        });
    };

    onMounted(() => {
        modal = new bootstrap.Modal(root.value);

        root.value.addEventListener('hidden.bs.modal', () => {
            global.showCollegeValidator = false;
        });
    });

    watch(() => global.showCollegeValidator, () => {
        if (global.showCollegeValidator) {
            modal.show();
        }
    });
</script>
